import { combineReducers } from 'redux';
import { adminManageReducer } from './manage/reducer';

export default combineReducers({
  manage: adminManageReducer
});
